module.exports = __webpack_public_path__ + "static/AvenirNext-UltraLight-8cbb0cd16d8d9c30ffb00d08a2533fbd.woff2";